import { Alert, AlertTitle } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { aodMissingMaterialsMessages } from '../../../../../messages';

/**
 * Explains that OLAF reprocess is blocked until materials are uploaded and the run is refreshed.
 */
export function MissingMaterialsGuidance() {
  return (
    <Alert severity="warning">
      <AlertTitle>
        <FormattedMessage {...aodMissingMaterialsMessages.guidanceTitle} />
      </AlertTitle>
      <FormattedMessage {...aodMissingMaterialsMessages.guidanceDescription} />
    </Alert>
  );
}
